module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authError) ? _c('div', {
    staticClass: "authenticate-error"
  }, [_c('p', [_vm._v("rmCloud couldn't sign you in.")]), _vm._v(" "), _c('p', {
    staticClass: "authenticate-error-detail"
  }, [_vm._v("Please reload the page. If this keeps happening, contact support and quote: " + _vm._s(_vm.authError))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cea5a4b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entry/AuthenticateView.vue
// module id = 1011
// module chunks = 1